import React from 'react';
import { useReducedMotion } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

const Reveal: React.FC<RevealProps> = ({ children, delay = 0, className }) => {
  const reduceMotion = useReducedMotion();

  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div
      className={[className, 'reveal-fast'].filter(Boolean).join(' ')}
      style={{ animationDelay: `${Math.max(0, delay) * 1000}ms` }}
    >
      {children}
    </div>
  );
};

export default Reveal;
